import React from 'react';
import '../../../static/styles/apiguide.scss';
import '../../../static/styles/dashboard.scss';

export default class ViewTicketBuyerInfoByOrderV2 extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <h3 className="mb0 mt40">티켓 구매자 정보 조회 주문번호로 그룹핑 V2 API</h3>

                <div className="blog-post-meta">
                    <span className="s-post">티켓 구매자에 대한 일반적인 정보를 주문번호로 그룹핑해 조회합니다. 이 API를 이용해 검색일의 구매자 정보를 가져올 수 있습니다. </span>
                    <h3 className="request-method">
                        <span className="label label-primary">GET</span>
                    </h3>
                </div>

                <div className="table-responsive">
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <td>Path</td>
                            <td>Example Endpoint</td>
                        </tr>
                        <tr>
                            <td>
                                /v2/providers/travel_backbone_api/apis/ticket-api/v2/purchasers/grouping-order-unit?dealId={'{dealId}'}&targetDate={'{targetDate}'}</td>
                            <td>
                                https://api-gateway.coupang.com/v2/providers/travel_backbone_api/apis/ticket-api/v2/purchasers/grouping-order-unit?dealId=3000001&targetDate=2018-08-01
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt40">
                    <h4>Request Parameters</h4>
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th>Name</th>
                            <th>Required</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td>dealId</td>
                            <td>true</td>
                            <td>Long</td>
                            <td>딜아이디</td>
                        </tr>
                        <tr>
                            <td>targetDate</td>
                            <td>true</td>
                            <td>Date</td>
                            <td>구매일자</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt40">
                    <h4>Response Specifications</h4>
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th>Name</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td>orderId</td>
                            <td>Long</td>
                            <td>주문번호</td>
                        </tr>
                        <tr>
                            <td>userName</td>
                            <td>String</td>
                            <td>구매자 이름</td>
                        </tr>
                        <tr>
                            <td>phoneNumber</td>
                            <td>String</td>
                            <td>전화번호</td>
                        </tr>
                        <tr>
                            <td>email</td>
                            <td>String</td>
                            <td>이메일</td>
                        </tr>
                        <tr>
                            <td>dealId</td>
                            <td>Long</td>
                            <td>딜번호</td>
                        </tr>
                        <tr>
                            <td>dealName</td>
                            <td>String</td>
                            <td>딜이름</td>
                        </tr>
                        <tr>
                            <td>optionId</td>
                            <td>Long</td>
                            <td>옵션번호</td>
                        </tr>
                        <tr>
                            <td>optionName</td>
                            <td>String</td>
                            <td>옵션이름</td>
                        </tr>
                        <tr>
                            <td>price</td>
                            <td>Long</td>
                            <td>가격</td>
                        </tr>
                        <tr>
                            <td>status</td>
                            <td>String</td>
                            <td>상태</td>
                        </tr>
                        <tr>
                            <td>purchaseDateTime</td>
                            <td>Date</td>
                            <td>구매일</td>
                        </tr>
                        <tr>
                            <td>canceledDateTime</td>
                            <td>Date</td>
                            <td>취소일</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt40">
                    <div className="panel panel-default">
                        <div className="panel-heading">
                            <h3 className="panel-title">응답값 예시</h3>
                        </div>
                        <div className="panel-body">
                <pre className="ty01">
                    {`
    {
        "100001":[
            {
                "ticketNumber": "9C320B-9000000000234",
                "userName": "김쿠팡",
                "phoneNumber": null,
                "email": "coupang@coupang.com",
                "dealId": 6500124641,
                "dealName": "쿠팡과 함께 바로셀로나",
                "optionId": 53000424227,
                "optionName": "즉시 가기  ",
                "price": "1,000",
                "purchaseDateTime": "2017-07-05 05:17:13",
                "canceledDateTime":"",
                "status": "PURCHASE_COMPLETE",
                "orderId":"100001"
            },
            {
                "ticketNumber": "DCAA6C-9000000000235",
                "userName": "김쿠팡",
                "phoneNumber": null,
                "email": "coupang@coupang.com",
                "dealId": 6500124641,
                "dealName": "쿠팡과 함께 바로셀로나",
                "optionId": 53000424227,
                "optionName": "즉시 가기  ",
                "price": "1,000",
                "purchaseDateTime": "2017-07-05 05:17:13",
                "canceledDateTime":"",
                "status": "PURCHASE_COMPLETE",
                "orderId":"100001"
            }
        ],
        "200001":[
            {
                "ticketNumber": "9C320B-9000000000234",
                "userName": "김쿠팡",
                "phoneNumber": null,
                "email": "coupang@coupang.com",
                "dealId": 6500124641,
                "dealName": "쿠팡과 함께 바로셀로나",
                "optionId": 53000424227,
                "optionName": "즉시 가기  ",
                "price": "1,000",
                "purchaseDateTime": "2017-07-05 05:17:13",
                "canceledDateTime":"",
                "status": "PURCHASE_COMPLETE",
                "orderId":"200001"
            }
        ],
    }
                    `}

                </pre>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./travel-developers-interface/src/main/client/apis/TicketAPIContent/TicketOrderInfoAPI/ViewTicketBuyerInfoByOrderV2.jsx